// ---------------------------------------------------------------------------
// LES ÉPISODES MARQUÉS VUS — la note qu'on pose à la main
//
// Toji, 14/09 : « pour les épisodes, on doit pouvoir clic droit pour noter ce
// qu'on a vu. Là, ce n'est pas le cas, pas tout le temps. C'est un peu bugué. »
//
// ⚠️ NE PAS CONFONDRE AVEC LA REPRISE. `reprises.js` sait où l'on s'est arrêté
// et s'écrit tout seul pendant qu'on regarde : il répond à « où en suis-je ? ».
// Ceci répond à « est-ce que je l'ai déjà fait ? », et RIEN ne l'écrit sans un
// geste explicite. C'est ce qui permet de marquer vu un épisode regardé
// ailleurs — précisément l'usage demandé.
//
// Ce module est séparé de `main.js` parce qu'il n'a besoin d'aucun DOM : c'est
// la règle de ce dépôt, et la seule façon d'éprouver ces règles sans monter une
// page entière.
// ---------------------------------------------------------------------------

/**
 * La marque d'un épisode, telle qu'elle est rangée : `"saison:épisode"`.
 *
 * Une chaîne plutôt qu'un objet : elle se sérialise court, se compare d'un
 * `includes`, et une liste de trois cents épisodes tient en quelques lignes du
 * fichier des bibliothèques — qui est la copie durable, relue à chaque
 * démarrage.
 */
export function marqueDEpisode(saison, episode) {
  const s = Math.max(0, Math.floor(Number(saison) || 0));
  const e = Math.max(0, Math.floor(Number(episode) || 0));
  return `${s}:${e}`;
}

/** Vrai si cette entrée de bibliothèque porte cet épisode comme vu. */
export function episodeEstVu(entree, saison, episode) {
  if (!Array.isArray(entree?.eps)) return false;
  return entree.eps.includes(marqueDEpisode(saison, episode));
}

/**
 * La liste après avoir inversé un épisode. PURE : elle ne touche à rien.
 *
 * ⚠️ ELLE REND LA LISTE ENTIÈRE, PAS UNE INSTRUCTION. Envoyer « ajoute 1:5 » ou
 * « retire 1:5 » paraît plus économe et se trompe dès que deux onglets cochent
 * en même temps : les deux instructions se rejouent dans un ordre quelconque et
 * produisent un état que personne n'a demandé. Avec l'état voulu, le dernier
 * qui écrit gagne — c'est prévisible, et c'est ce qu'on veut d'une case à
 * cocher.
 */
export function listeApresBascule(eps, marque) {
  const avant = Array.isArray(eps) ? eps.filter((x) => typeof x === 'string') : [];
  return avant.includes(marque) ? avant.filter((x) => x !== marque) : [...avant, marque];
}

/**
 * Combien d'épisodes d'une saison sont marqués vus.
 *
 * Sert à dire « 8 / 12 » en tête de saison — l'information qu'on cherche en
 * ouvrant une série qu'on a commencée il y a trois mois.
 */
export function vusDeLaSaison(entree, saison, episodes = []) {
  if (!Array.isArray(entree?.eps) || !episodes.length) return 0;
  const dedans = new Set(entree.eps);
  return episodes.filter((e) => dedans.has(marqueDEpisode(saison, e))).length;
}
